import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img1 from '../assets/others/11102044.jpg'
import img3 from '../assets/others/11102045.jpg'
import img2 from '../assets/icons/icn-1.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet-async'
library.add(fas)

const Instructor= () => {
  return (
    <div>
        <Helmet>
        <title>Apply as a VLSI Trainer – Careers at Takshila | Takshila VLSI</title>
        <meta name="description" content="Apply for a VLSI trainer position and share your semiconductor industry expertise with aspiring engineers through faculty opportunities at Takshila VLSI." />
        <link rel="canonical" href="https://www.takshila-vlsi.com/apply-trainer/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Apply as a VLSI Trainer – Careers at Takshila | Takshila VLSI" />
        <meta property="og:description" content="Apply for a VLSI trainer position and share your semiconductor industry expertise with aspiring engineers through faculty opportunities at Takshila VLSI." />
        <meta property="og:url" content="https://www.takshila-vlsi.com/apply-trainer/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2024-07-16T17:46:03+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
    <Header/>
    <main>
    <section className='section-banner pg-banner p-lg-5'>
            <div class="container">
                          <div class="row">
                              <div class="col-lg-6 align-self-center">
                                <div class="pg-title-sec pe-lg-5 p-4">
                                    <h1 className='pg-title pb-lg-3'>Become an <span class="bg-txt">Instructor</span> Today</h1>
                                    <p className='pg-title-desc'>We’re on a mission to deliver engaging, curated courses at a reasonable price.
                                     </p>
                                </div>
                                <div class="col-md-12 align-self-center ps-4 pb-4">
                                    <a href='#contact'>
                                    <button class="btn-primary btn-icon ms-0">Apply Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                 </a>
                                 </div>
                              </div>
                              <div class="col-md-6 img-radius">
                            <img src={img1} alt=''/>
                          </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-md-6 img-radius">
                            
                          </div>
                          </div>
            </div>
            </section>
            <section className='we-offer-section ws-section pb-5'>
            <div class="container">
                    <div class="row justify-content-start">
                        <div class="col-lg-12 text-center">
                        <h2 class="ws-section_heading pd-03 mb-4">What We Offer</h2>
                        </div>
                    </div>
                  
                    <div class="row g-4">
                            <div class="col-lg-4">
                                <div className='icon-card bg-10 radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>Professional Growth</div>
                                        <p>Progressing through your career path by taking on increasingly challenging roles or responsibilities that align with your professional goals.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                            <div className='icon-card bg-drk dark-bg radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>The System Of Bonuses</div>
                                        <p>Bonuses serve various, such as motivating employee to achieves specific goals, rewarding outstanding.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                            <div className='icon-card bg-10 radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>Comfortable working Condition</div>
                                        <p>Comfortable working conditions refer to the physical, environment, and sometimes psychological aspects of workplace that contribute to the well-being, productivity. </p>
                                   
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                            <div className='icon-card bg-drk dark-bg radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>Competitive Salary</div>
                                        <p>Its is part of an organisation overall Employee Value Proposition (EVP), which includes benefits, perks, work environment and career development. </p>
                                   </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                            <div className='icon-card bg-10 radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>Educational Programs</div>
                                        <p>Encompass a wide range of structured learning experience designed to impart knowledge, skills.</p>
                                   </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                            <div className='icon-card bg-drk dark-bg radius-1 mb-lg-3'>
                                    <div className='icon mb-3'> <img src={img2} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-3'>Development of your skill</div>
                                        <p>Developing your skills involves a deliberate and continuous effort to improve your capabilities, knowledge, and expertise. </p>
                                    </div>
                                </div>
                            </div>
                     </div>  
            </div>
            </section>
            <section className='connect-section ws-section pb-5'>
                <div className='container'>
                <div class="row">
                        <div class="col-lg img-radius mb-3">
                        <img src={img3} alt=''/>
                        </div>
                        <div class="col-lg" id='contact'>
                        <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="930"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/ApplyasTrainer/formperma/5lECvk6Hol022007mgD7sg11vYMEZTExc-gpXkx_XpA`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                  </div>
                        
                    </div>
                    </div>
          </section>
    </main>
    <Enrollaction/>
    <Partnersec/> 
    <Footer/>
    </div>
  )
}

export default Instructor

